import React from "react";
import Svg, { Path, Circle } from "react-native-svg";

const PhoneIcon = (props) => (
  <Svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M6.71867 9.28252C5.28545 7.8493 4.96183 6.41608 4.88882 5.84186C4.86842 5.68308 4.92306 5.52386 5.03665 5.41106L6.19648 4.25175C6.3671 4.08124 6.39737 3.81551 6.26949 3.61099L4.42282 0.743512C4.28134 0.517047 3.99084 0.435313 3.75203 0.554781L0.787471 1.95098C0.594354 2.04607 0.480765 2.25126 0.502691 2.4654C0.658026 3.94108 1.30137 7.56866 4.8663 11.1338C8.43123 14.699 12.0583 15.3421 13.5348 15.4975C13.7489 15.5194 13.9541 15.4058 14.0492 15.2127L15.4454 12.2481C15.5644 12.0098 15.4832 11.7201 15.2577 11.5784L12.3902 9.73221C12.1858 9.6042 11.9201 9.63426 11.7494 9.8047L10.5901 10.9645C10.4773 11.0781 10.3181 11.1328 10.1593 11.1124C9.58511 11.0394 8.15189 10.7157 6.71867 9.28252Z"
      fill={props.fill ? props.fill : "rgba(0,0,0,0.5)"}
      fill-opacity="0.5"
    />
  </Svg>
);

export default PhoneIcon;
